import { render, staticRenderFns } from "./leftFold.vue?vue&type=template&id=eb3bd5ca&scoped=true&"
import script from "./leftFold.vue?vue&type=script&lang=js&"
export * from "./leftFold.vue?vue&type=script&lang=js&"
import style0 from "./leftFold.vue?vue&type=style&index=0&id=eb3bd5ca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3bd5ca",
  null
  
)

export default component.exports